module.exports = __webpack_public_path__ + "HelveticaNeue-Thin.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/helvetica-neue/HelveticaNeue-Thin.woff
// module id = 45
// module chunks = 66 67